module.exports = __webpack_public_path__ + "img/vision.5434f493.jpg";